<template>
  <v-app>
    <div id="app">
      <BaseSnackbar top right :data="snackbar" />
      <TheLayout v-if="isAuthenticated" />
      <TheSimpleLayout v-else />
    </div>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import TheLayout from "./components/TheLayout";
import TheSimpleLayout from "./components/TheSimpleLayout";
import BaseSnackbar from "@/components/BaseSnackbar";
import { mapActions } from "vuex";

export default {
  name: "app",
  computed: {
    ...mapState({
      snackbar: state => state.common.snackbar
    }),
    isAuthenticated() {
      return this.$auth.isAuthenticated();
    },
  },
  methods: {
    ...mapActions(['autoLoginByToken']),
    setUserLocale(locale) {
      window.localStorage.setItem("locale", locale);
    },
  },
  components: {
    TheLayout,
    TheSimpleLayout,
    BaseSnackbar
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler() {
        if (! this.$auth.isAutoLoginDoNotMatch()) {
          return;
        }

        this.autoLoginByToken({vm: this}).then(() => {
          if (this.$auth.isAuthenticated()) {
               location.reload();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
